import React from 'react';
import { List, Datagrid, TextField, DateField } from 'react-admin';

const NotificationList = props => (
  <List {...props} bulkActionButtons={false}>
    <Datagrid>
      <TextField source="data.message" label="Message" sortable={false} />
      <TextField source="data.url" label="URL" sortable={false} />
      <DateField source="created_at" showTime sortable={false} />
    </Datagrid>
  </List>
);

export default NotificationList;



// WEBPACK FOOTER //
// ./src/resources/notifications/NotificationList.jsx